import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import * as SlideActions from "../data/slides/SlideActions";

import Whiteboard from "Components/Whiteboard";
import SlideTrack from "Components/SlideTrack";
import BlankEditor from "Components/BlankStates/BlankEditor";
import SlideTrackSkeleton from 'Components/Skeletons/SlideTrackSkeleton';
import SlideSkeleton from 'Components/Skeletons/SlideSkeleton';
import EditableTitle from "Components/EditableTitle";
import StorySettingsMenu from "Components/StorySettingsMenu";

import { ArrowLeftIcon } from "@heroicons/react/solid";
import Sidebar from "Components/Sidebar";

class EditorController extends React.Component
{
    state = {
        currentSlide: null,
        elementId: null,

        showShareModal: false,
        showPublishModal: false,
    };

    static propTypes = {
        loading: PropTypes.bool.isRequired,

        story: PropTypes.object,
        slides: PropTypes.array,
        elements: PropTypes.object,

        createSlide: PropTypes.func.isRequired,
        editSlide: PropTypes.func.isRequired,
    };

    changeElement = (elementId) => {
        this.setState({elementId: elementId});
    };

    changeSlide = (slideId) => {
        this.setState({
            currentSlide: slideId.toString(),
            elementId: null
        })
    };

    createSlide = (type) => {
        this.props.createSlide(this.props.story.id, type).then(slide => {
            this.changeSlide(slide.id);
        });
    };

    static getDerivedStateFromProps(props, state)
    {
        return {
            ...state,
            currentSlide: EditorController.getCurrentSlideId(props, state)
        }
    }

    render()
    {
        if (! this.props.story) {
            // perhaps story is still loading?
            return null;
        }

        const slide = _.find(this.props.slides, ['id', this.state.currentSlide]);

        return <div className="h-full flex flex-col flex-grow">
            <div className='bg-white border-b flex items-center py-2 h-16'>
                <Link to={`/`} className='border-r border-gray-200 px-6 py-4'>
                    <ArrowLeftIcon className='w-4' />
                </Link>
                {
                    this.props.story &&
                        <div className='px-4 flex w-full'>
                            <EditableTitle storyId={this.props.story.id} value={this.props.story.name} />

                            <div className='flex-grow' />

                            {
                                /*<ElementToolbar slide={slide} changeElement={this.changeElement} />*/
                            }
                        </div>
                }
                {
                    this.props.story &&
                        <div className='flex border-l border-gray-200 px-5 py-4 ml-2'>
                            <StorySettingsMenu story={this.props.story} />
                        </div>
                }
            </div>
            <div className='flex flex-grow overflow-hidden'>
                { this.renderTrack() }
                { this.renderWhiteboard(slide) }
                { this.renderBlankEditor() }
            </div>
        </div>;
    }

    renderTrack()
    {
        if (this.props.slides.length === 0) {
            return null;
        }

        return <div className='w-18 border-r'>
            {
                this.props.loading
                    ? <SlideTrackSkeleton />
                    : <SlideTrack
                        storyId={this.props.story.id}
                        current={this.state.currentSlide}
                        slides={this.props.slides}
                        onClick={this.changeSlide}
                        createSlide={this.createSlide}
                        changeElement={this.changeElement}
                    />
            }
        </div>;
    }

    renderWhiteboard(slide)
    {
        if ( this.props.loading || ! this.props.story ) {
            return <div className='flex flex-grow flex-row'>
                <div className='m-auto'>
                    <SlideSkeleton />
                    <div className='mb-24' />
                </div>
                <div className='w-64'>
                    <Sidebar />
                </div>
            </div>;
        }

        if (! slide) {
            return null;
        }

        return <Whiteboard
            slide={slide}
            elements={this.props.elements}
            elementId={this.state.elementId}
            changeElement={this.changeElement}
            save={this.props.editSlide}
        />;
    }

    renderBlankEditor()
    {
        if (! this.props.loading && this.props.slides.length === 0) {
            return <BlankEditor
                storyId={this.props.story.id}
                changeSlide={this.changeSlide}
            />;
        }
    }

    static getCurrentSlideId(props, state)
    {
        // because we'll get some slide, render
        // then more, and render, and more...
        // we don't want to set the state on the first slide..
        if (props.loading) {
            return null;
        }

        // But, if we have state, let's just use that
        if (state.currentSlide) {
            return state.currentSlide;
        }

        // Otherwise, if no slide is selected, let's default
        // to the firsts slide.

        // Which we cannot do, if there are no slides...
        if (props.slides.length === 0) {
            return;
        }

        // Let's order them and grab the first.
        const firstSlide = _.head(_.orderBy(props.slides, 'position', 'asc'));

        // From here-on in, we'll assume we have a slide.
        // Otherwise, something else went wrong.
        if (! firstSlide) {
            return;
        }

        // And we're done - return the ID
        return firstSlide.id.toString();
    }
}

const mapStateToProps = (state, ownProps) => ({
    story: state.stories[ownProps.storyId],
    slides: _.filter(state.slides, ['story_id', ownProps.storyId]),
    elements: state.elements, // urgh... using this when building <Properties/>
});

const mapDispatchToProps = {
    createSlide: SlideActions.createSlide,
    editSlide: SlideActions.editSlide,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditorController);